export enum POST_HOG_EVENT {
  WELCOME_JOIN = 'Join from Welcome',
}
